<template>
  <v-dialog
    v-model="dialog"
    max-width="700"
    persistent
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-card>
      <v-toolbar color="primary" dark flat short class="px-2">
        <v-toolbar-title>Color Family</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="cancel()" icon><v-icon>fas fa-times</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="mt-12">
        <v-form @submit.prevent>

          <v-text-field
            outlined
            class="mb-2"
            v-model="attributes.code"
            :error-messages="errors.code"
            label="Code"
          ></v-text-field>

          <v-text-field
            outlined
            class="mb-2"
            v-model="attributes.name"
            :error-messages="errors.name"
            label="Name"
          ></v-text-field>

          <v-checkbox
              v-model="attributes.is_active"
              :error-messages="errors.is_active"
              label="Active"
              :false-value="false"
              :true-value="true"
            ></v-checkbox>

        </v-form>
      </v-card-text>

      <v-card-actions class="px-6 pb-8">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="px-5"
          large
          outlined
          depressed
          @click="cancel()"
        >{{ cancelButtonText }}</v-btn>
        <v-btn
          color="primary"
          class="px-5"
          large
          depressed
          @click="save()"
        >{{ saveButtonText }}</v-btn>
      </v-card-actions>

    </v-card>

  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'

export default {
  props: {
    value: Boolean,
    attributes: Object,
    errors: Object,
    cancelButtonText: {
      default: 'Cancel',
    },
    saveButtonText: {
      default: 'Save',
    },
  },
  setup(props, context) {
    const dialog = ref(false)

    watch(() => props.value, val => {
      dialog.value = val
    })

    watch(dialog, val => {
      context.emit('input', val)
    })

    function save() {
      context.emit('save')
    }

    function cancel() {
      dialog.value = false
      context.emit('cancel')
    }

    function show() {
      dialog.value = true
    }

    function hide() {
      dialog.value = false
    }

    return {
      dialog,

      save,
      cancel,

      show,
      hide,
    }
  }}
</script>